"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _DateiBase = _interopRequireDefault(require("./DateiBase"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The RentalItem model module.
 * @module model/RentalItem
 * @version 0.0.1
 */
class RentalItem {
  /**
   * Constructs a new <code>RentalItem</code>.
   * @alias module:model/RentalItem
   * @param name {String} 
   * @param beschreibung {String} 
   * @param preis {Number} 
   * @param id {Number} 
   */
  constructor(name, beschreibung, preis, id) {
    RentalItem.initialize(this, name, beschreibung, preis, id);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, name, beschreibung, preis, id) {
    obj['name'] = name;
    obj['beschreibung'] = beschreibung;
    obj['preis'] = preis;
    obj['id'] = id;
  }

  /**
   * Constructs a <code>RentalItem</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RentalItem} obj Optional instance to populate.
   * @return {module:model/RentalItem} The populated <code>RentalItem</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new RentalItem();
      if (data.hasOwnProperty('name')) {
        obj['name'] = _ApiClient.default.convertToType(data['name'], 'String');
      }
      if (data.hasOwnProperty('beschreibung')) {
        obj['beschreibung'] = _ApiClient.default.convertToType(data['beschreibung'], 'String');
      }
      if (data.hasOwnProperty('bild')) {
        obj['bild'] = _DateiBase.default.constructFromObject(data['bild']);
      }
      if (data.hasOwnProperty('preis')) {
        obj['preis'] = _ApiClient.default.convertToType(data['preis'], 'Number');
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'Number');
      }
      if (data.hasOwnProperty('available')) {
        obj['available'] = _ApiClient.default.convertToType(data['available'], 'Boolean');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>RentalItem</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>RentalItem</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of RentalItem.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
      throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
    }
    // ensure the json data is a string
    if (data['beschreibung'] && !(typeof data['beschreibung'] === 'string' || data['beschreibung'] instanceof String)) {
      throw new Error("Expected the field `beschreibung` to be a primitive type in the JSON string but got " + data['beschreibung']);
    }
    // validate the optional field `bild`
    if (data['bild']) {
      // data not null
      _DateiBase.default.validateJSON(data['bild']);
    }
    return true;
  }
}
RentalItem.RequiredProperties = ["name", "beschreibung", "preis", "id"];

/**
 * @member {String} name
 */
RentalItem.prototype['name'] = undefined;

/**
 * @member {String} beschreibung
 */
RentalItem.prototype['beschreibung'] = undefined;

/**
 * @member {module:model/DateiBase} bild
 */
RentalItem.prototype['bild'] = undefined;

/**
 * @member {Number} preis
 */
RentalItem.prototype['preis'] = undefined;

/**
 * @member {Number} id
 */
RentalItem.prototype['id'] = undefined;

/**
 * @member {Boolean} available
 */
RentalItem.prototype['available'] = undefined;
var _default = exports.default = RentalItem;